import { Injectable } from '@angular/core';
import { factory } from 'src/app/config/constants';

@Injectable()
export class PersonalFactoryService {
  constructor() {
  }

  setPersonalId(personalId: any) {
    sessionStorage.setItem(factory.personalId, personalId);
  }

  getPersonalId(): string {
    try {
      return sessionStorage.getItem(factory.personalId);
    } catch (e) {
      return '';
    }
  }

  removePersonalId(){
    sessionStorage.removeItem(factory.personalId)
  }
}
